<div class="wrapper">
  <div class="back-link-container confinement">
    <a routerLink=".." class="back-on-mobile mat-h2 back-link"
      ><mat-icon class="back-link-icon">arrow_back</mat-icon>{{ 'ACCOUNT.PAYMENT_METHODS' | translate }}</a
    >
  </div>
  <mat-card class="upper-card confinement">
    <span class="mat-title">{{ 'ACCOUNT.ADD_PAYMENT_METHOD.TITLE' | translate }}</span>
  </mat-card>
  <mat-card class="lower-card confinement payment-method-info">
    <div>
      <p class="mat-display-2">{{ 'ACCOUNT.ADD_PAYMENT_METHOD.DEBIT_CHARGE.TITLE' | translate }}</p>
      <mat-card-content class="mat-card-info mat-body-2">{{
        'ACCOUNT.ADD_PAYMENT_METHOD.DEBIT_CHARGE.INFO' | translate
      }}</mat-card-content>
      <a
        mat-button
        routerLink="/navigation/account/payment-methods/new/debit-charge"
        color="primary"
        class="mat-card-info"
        >{{ 'ACCOUNT.ADD_PAYMENT_METHOD.DEBIT_CHARGE.BUTTON' | translate }}</a
      >
    </div>
    <span class="hide-on-xs sepa-logo"><img src="assets/img/SepaLogoEN.jpg" alt="SEPA logo" /></span>
  </mat-card>
  <!--  <mat-card-->
  <!--    class="content-box upper-card lower-card confinement"-->
  <!--  >-->
  <!--    <div>-->
  <!--      <p class="mat-display-2">{{ 'ACCOUNT.ADD_PAYMENT_METHOD.CREDIT_CARD.TITLE' | translate }}</p>-->
  <!--      <mat-card-content class="mat-card-info mat-body-2">{{-->
  <!--        'ACCOUNT.ADD_PAYMENT_METHOD.CREDIT_CARD.INFO' | translate-->
  <!--      }}</mat-card-content>-->
  <!--      <a-->
  <!--        mat-button-->
  <!--        routerLink="/navigation/account/payment-methods/new/credit-card"-->
  <!--        color="primary"-->
  <!--        class="mat-card-info"-->
  <!--        ngClass.sm="credit-card-button"-->
  <!--        >{{ 'ACCOUNT.ADD_PAYMENT_METHOD.CREDIT_CARD.BUTTON' | translate }}</a-->
  <!--      >-->
  <!--    </div>-->
  <!--    <span -->
  <!--      ><img class="visa" src="assets/img/Visa_2021.svg" alt="Visa logo" />-->
  <!--      <img src="assets/img/mc_symbol.svg" alt="Mastercard logo" />-->
  <!--    </span>-->
  <!--  </mat-card>-->
  <!--  <mat-card-->
  <!--    class="content-box lower-card confinement"-->
  <!--  >-->
  <!--    <div gdArea="content">-->
  <!--      <p class="mat-display-2">{{ 'ACCOUNT.ADD_PAYMENT_METHOD.PAYPAL.TITLE' | translate }}</p>-->
  <!--      <mat-card-content class="mat-card-info mat-body-2">{{-->
  <!--        'ACCOUNT.ADD_PAYMENT_METHOD.PAYPAL.INFO' | translate-->
  <!--      }}</mat-card-content>-->
  <!--      <a mat-button routerLink="/navigation/account/payment-methods/new/paypal" color="primary" class="mat-card-info">{{-->
  <!--        'ACCOUNT.ADD_PAYMENT_METHOD.PAYPAL.BUTTON' | translate-->
  <!--      }}</a>-->
  <!--    </div>-->
  <!--    <span gdArea="logo" ngClass.xs="hidden"><img src="assets/img/de-pp-logo-200px.png" alt="PayPal logo" /></span>-->
  <!--  </mat-card>-->
</div>
